__turbopack_context__.v({
  "container": "ImageTag-module-scss-module__gMDHGG__container",
  "imgTagTextContainer": "ImageTag-module-scss-module__gMDHGG__imgTagTextContainer",
});
